<template>
  <td colspan="12" style="background: #f6f6f6;" class="pa-0">
    <div class="table-expanded">
      <div class="my-4 table-expanded__content">
        <ListLocationsImport type="mass" :model="model" displayType="show" :descriptionColumn="descriptionColumn" />
        <v-divider class="my-4" />
        <ListLocationsImport type="retail" :model="model" displayType="show" :descriptionColumn="descriptionColumn" />
      </div>
    </div>
  </td>
</template>
<script>
import ListLocationsImport from './ListLocationsImport.vue'
export default {
  components: { ListLocationsImport },
  props: {
    model: Object,
    descriptionColumn: {
      type: Number,
      default: null
    }
  },
  name: 'TableExpandProduct'
}
</script>
<style lang="scss" scoped>
.table-expanded {
  width: calc(100% - 136px);
  margin-left: 136px;
  padding-right: 106px;
}
</style>
